export default __webpack_public_path__ + "static/media/wep.1d8cd87a.jpg";